import { getValidAccessToken } from "../../../../../utils/authRefresh";

function appendHiddenInput(form: HTMLFormElement, name: string, value: string): void {
  const input = document.createElement("input");
  input.type = "hidden";
  input.name = name;
  input.value = value;
  form.appendChild(input);
}

export function submitHiddenDownloadForm(action: string, targetName: string, fields: Record<string, string>): void {
  if (typeof document === "undefined" || typeof window === "undefined") {
    throw new Error("Document is unavailable for web file download");
  }

  const iframe = document.createElement("iframe");
  iframe.name = targetName;
  iframe.style.display = "none";

  const form = document.createElement("form");
  form.method = "POST";
  form.action = action;
  form.target = targetName;
  form.style.display = "none";

  Object.entries(fields).forEach(([name, value]) => appendHiddenInput(form, name, value));

  document.body.appendChild(iframe);
  document.body.appendChild(form);
  form.submit();

  window.setTimeout(() => {
    form.remove();
    iframe.remove();
  }, 60_000);
}

export async function submitAuthenticatedHiddenDownloadForm(
  action: string,
  targetName: string,
  fields: Record<string, string>,
  missingTokenMessage = "Missing access token for file download"
): Promise<void> {
  const token = await getValidAccessToken();
  if (!token) {
    throw new Error(missingTokenMessage);
  }

  submitHiddenDownloadForm(action, targetName, {
    token,
    ...fields,
  });
}

export function getManagedFileDownloadAction(url: string): string | null {
  if (typeof document === "undefined" || typeof window === "undefined") {
    return null;
  }

  const managedFilePattern = /^\/api\/file\/[^/]+\/download(?:\?.*)?$/;
  if (managedFilePattern.test(url)) {
    return url;
  }

  try {
    const parsedUrl = new URL(url, window.location.origin);
    if (parsedUrl.origin !== window.location.origin) {
      return null;
    }

    const action = `${parsedUrl.pathname}${parsedUrl.search}`;
    return managedFilePattern.test(action) ? action : null;
  } catch {
    return null;
  }
}
